<script lang="ts" setup>
import CreateProjectForm from '@panel/components/project/create/CreateProjectForm.vue';
import useViewTitle from '@panel/composables/useViewTitle';
import SinglePageLayout from '@panel/layouts/Layout.SinglePage.vue';
import Size from 'gpcore-uikit/interfaces/Size';
import { useRouter } from 'vue-router';

useViewTitle('Create project');

const router = useRouter();

const onProjectCreated = (projectId: string) => {
  router.push({
    name: 'ProjectMembers',
    params: {
      projectId,
    },
  });
};
</script>

<template>
  <SinglePageLayout :content-size="Size.Tiny" v-playwright="'project-create-view'">
    <template #content>
      <h2 class="tw-mb-4">Create a new project</h2>

      <CreateProjectForm @created="onProjectCreated" />
    </template>
  </SinglePageLayout>
</template>
